/**
 * ImageSeoBadge — widoczna w kreatorach informacja, że zdjęcia są
 * przygotowywane pod Google i wyszukiwarki AI. Buduje zaufanie do produktu.
 */
import { ShieldCheck } from 'lucide-react';

export function ImageSeoBadge({ className = '' }) {
  return (
    <div
      data-testid="image-seo-badge"
      className={`flex items-start gap-2.5 rounded-xl border border-emerald-200 bg-emerald-50/70 px-3.5 py-3 ${className}`}
    >
      <div className="w-7 h-7 rounded-lg bg-emerald-100 flex items-center justify-center flex-shrink-0 mt-0.5">
        <ShieldCheck className="w-4 h-4 text-emerald-600" />
      </div>
      <div className="min-w-0">
        <p className="text-[13px] font-semibold text-emerald-900 leading-snug">
          Zdjęcia zoptymalizowane pod Google i wyszukiwarki AI
        </p>
        <p className="text-[12px] text-emerald-700 leading-snug mt-0.5">
          Automatycznie zmniejszamy je do lekkiego formatu WebP, dodajemy opisy i zgłaszamy do wyszukiwarek —
          Twoje zdjęcia ładują się szybciej i łatwiej je znaleźć.
        </p>
      </div>
    </div>
  );
}

export default ImageSeoBadge;
